import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import QuotesLogger from 'quotes-ui-lib/tracking/quotesLogger';
import { getIsPublished } from 'quotes-ui-lib/utils/status';
import { getQuoteActivityUrl } from 'quotes-ui-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ActivityButton = ({
  quote,
  trackingLocation
}) => {
  const trackAction = action => {
    QuotesLogger.log('quoteInteraction', {
      action,
      location: trackingLocation
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "activity-btn",
    "data-selenium-test": "activity-btn",
    use: "tertiary-light",
    responsive: false,
    size: "extra-small",
    href: getQuoteActivityUrl(quote),
    onClick: () => trackAction('Click activity button'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.activity.buttonText"
    })
  }, "activityButton");
};
export default ActivityButton;
export const showActivityButton = quote => {
  return getIsPublished(quote);
};